import {
  UnitListSuccess,
  UnitDetailsSuccess,
  UnitGetFilterSuccess,
} from '../../actionTypes/manufactureUnitActions';
const inititalState = {
  unitList: [],
  unitDetails: {},
  unitFilter: {},
};
export const manufactureUnitReducer = (state = inititalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case UnitListSuccess:
      return {
        ...state,
        unitList: payload,
      };
    case UnitDetailsSuccess:
      return {
        ...state,
        unitDetails: payload,
      };
    case UnitGetFilterSuccess:
      return {
        ...state,
        unitFilter: payload,
      };
    default:
      return state;
  }
};
